import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('dashboard');
const GET_PAYMENT_ACCOUNT = define('GET_PAYMENT_ACCOUNT', true);
const SET_PAYMENT_ACCOUNT = define('SET_PAYMENT_ACCOUNT', true);

const initialState = {
  data: {},
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_ACCOUNT.PENDING:
      return {
        loading: true,
        data: {},
      };
    case GET_PAYMENT_ACCOUNT.RESOLVED:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case GET_PAYMENT_ACCOUNT.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case SET_PAYMENT_ACCOUNT.PENDING:
      return {
        loading: true,
        data: {},
      };
    case SET_PAYMENT_ACCOUNT.RESOLVED:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case SET_PAYMENT_ACCOUNT.REJECTED:
      return {
        ...state,
        loading: false,
      };
    default: return state;
  }
}

export const actions = {
  setPaymentAccount: (id, data) => ({
    type: SET_PAYMENT_ACCOUNT,
    promise: api.post(`/affiliate/payment-account/${id}`, { ...data })
  })
}


// WEBPACK FOOTER //
// ./src/ducks/paymentMethod.js